import React, { useState, useEffect, useRef } from 'react';
import { HiChevronUpDown } from "react-icons/hi2";

function CustomMultipleSelectDropdown({ options, label, onChange }) {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const dropdownRef = useRef(null);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const handleOptionClick = (option) => {
        let updatedSelectedOptions;
        if (selectedOptions.includes(option)) {
            updatedSelectedOptions = selectedOptions.filter((item) => item !== option);
        } else {
            updatedSelectedOptions = [...selectedOptions, option];
        }

        setSelectedOptions(updatedSelectedOptions);

        // Propagate selected options to parent component through onChange
        if (onChange) {
            onChange(updatedSelectedOptions);
        }
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className="custom-multiple-select" ref={dropdownRef}>
            <label>{label}</label>
            <div className="dropdown" onClick={toggleDropdown}>
                <div className="dropdown-head">
                    {selectedOptions.length > 0
                        ? selectedOptions.join(', ')
                        : 'Select options'}
                    <span className="dropdown-icon"><HiChevronUpDown /></span>
                </div>
                {isOpen && (
                    <div className="dropdown-popup">
                        {options.map((categoryGroup, index) => (
                            <div key={index} className="dropdown-category">
                                <strong>{categoryGroup.category}</strong>
                                {categoryGroup.options.map((option, i) => (
                                    <div
                                        key={i}
                                        className={`dropdown-option ${
                                            selectedOptions.includes(option) ? 'selected' : ''
                                        }`}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleOptionClick(option);
                                        }}
                                    >
                                        <input
                                            type="checkbox"
                                            checked={selectedOptions.includes(option)}
                                            readOnly
                                        />
                                        {option}
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}

export default CustomMultipleSelectDropdown;
